/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions
} from '@tanstack/react-query'
import type {
  ClientsTokenObtainPairRequest
} from '../../model/clientsTokenObtainPairRequest'
import type {
  ClientsTokenRefreshRequest
} from '../../model/clientsTokenRefreshRequest'
import type {
  ClientsTokenRefreshResponse
} from '../../model/clientsTokenRefreshResponse'
import type {
  StytchTokenDataRequest
} from '../../model/stytchTokenDataRequest'
import type {
  TokenObtainPairResponse
} from '../../model/tokenObtainPairResponse'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Returns a JWT token for a user
 */
export const tokenCreate = (
    clientsTokenObtainPairRequest: ClientsTokenObtainPairRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<TokenObtainPairResponse>(
      {url: `/token/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: clientsTokenObtainPairRequest
    },
      options);
    }
  


export const getTokenCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tokenCreate>>, TError,{data: ClientsTokenObtainPairRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof tokenCreate>>, TError,{data: ClientsTokenObtainPairRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tokenCreate>>, {data: ClientsTokenObtainPairRequest}> = (props) => {
          const {data} = props ?? {};

          return  tokenCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TokenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tokenCreate>>>
    export type TokenCreateMutationBody = ClientsTokenObtainPairRequest
    export type TokenCreateMutationError = unknown

    export const useTokenCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tokenCreate>>, TError,{data: ClientsTokenObtainPairRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTokenCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns a JWT token for a user
 */
export const tokenRefreshCreate = (
    clientsTokenRefreshRequest: ClientsTokenRefreshRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<ClientsTokenRefreshResponse>(
      {url: `/token/refresh/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: clientsTokenRefreshRequest
    },
      options);
    }
  


export const getTokenRefreshCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tokenRefreshCreate>>, TError,{data: ClientsTokenRefreshRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof tokenRefreshCreate>>, TError,{data: ClientsTokenRefreshRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tokenRefreshCreate>>, {data: ClientsTokenRefreshRequest}> = (props) => {
          const {data} = props ?? {};

          return  tokenRefreshCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TokenRefreshCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tokenRefreshCreate>>>
    export type TokenRefreshCreateMutationBody = ClientsTokenRefreshRequest
    export type TokenRefreshCreateMutationError = unknown

    export const useTokenRefreshCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tokenRefreshCreate>>, TError,{data: ClientsTokenRefreshRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTokenRefreshCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Obtain a JWT token from a Stytch token
 */
export const tokenStytchCreate = (
    stytchTokenDataRequest: StytchTokenDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<TokenObtainPairResponse>(
      {url: `/token/stytch/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stytchTokenDataRequest
    },
      options);
    }
  


export const getTokenStytchCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tokenStytchCreate>>, TError,{data: StytchTokenDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof tokenStytchCreate>>, TError,{data: StytchTokenDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tokenStytchCreate>>, {data: StytchTokenDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  tokenStytchCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TokenStytchCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tokenStytchCreate>>>
    export type TokenStytchCreateMutationBody = StytchTokenDataRequest
    export type TokenStytchCreateMutationError = unknown

    export const useTokenStytchCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tokenStytchCreate>>, TError,{data: StytchTokenDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getTokenStytchCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    